import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import web1 from "../../assets/images/web.png";
import web2 from "../../assets/images/web2.png";

const WebSection = () => {
  const dataContext = useContext(AuthContext);
  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`w-full px-6 sm:px-10 md:px-20 transition-all duration-500 ${
        theme === "dark" ? "bg-white text-black" : "bg-black text-white"
      }`}
    >
      <section className="max-w-[1536px] mx-auto transition-all duration-500">
        {/* Websites Section */}
        <h1
          className={`font-bold bricolage-grotesque-bold flex justify-center items-center py-4 md:py-12   text-center transition-all duration-500 ${
            theme === "dark" ? "text-black" : "text-white"
          } text-[28px] sm:text-[36px] md:text-[44px] lg:text-[52px]`}
        >
          Websites
        </h1>

        {/* Image 1 with clickable link */}
        <div className="md:py-8 flex justify-center items-center cursor-pointer">
          <a
            href="https://redtrucking.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="w-full"
          >
            <img
              src={web1}
              alt="Red Trucking Website"
              className="w-full hover:opacity-90 transition-all duration-300"
            />
          </a>
        </div>

        {/* Image 2 */}
        <div className="py-3 md:py-28 flex justify-center items-center">
          <a href="https://culinary-fe.vercel.app/" className="" target="_blank">
            <img src={web2} alt="Website Design 2" className="w-full" />
            </a>
        </div>
      </section>
    </div>
  );
};

export default WebSection;
